var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badgepopup"},[_c('div',{staticClass:"popup"},[_c('em',{staticClass:"close cursor",on:{"click":_vm.close}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.popupData.path,"alt":""}}),_vm._v(" "),_c('div',[_c('h2',[_vm._v(_vm._s(_vm.popupData.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.popupData.badge_msg))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-199e2a87","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bussiness/class/badgepopup.vue
// module id = null
// module chunks = 